import React, { useEffect, useState, useRef } from 'react';
import usePermissions from 'hooks/permissions-hooks';
import { TextField, Box, Tooltip } from '@material-ui/core';
import IconButton from '@material-ui/core/IconButton';
import SearchIcon from '@material-ui/icons/Search';
import InfoIcon from '@material-ui/icons/Info';
import * as _ from 'lodash';

import Autocomplete from '@material-ui/lab/Autocomplete';

const SearchBarForReport = ({ setFilterQuery }) => {
  const [ value, setValue ] = useState([]);
  const { role } = usePermissions();
  const inputRef = useRef(null);

  const handleClick = () => {
    // case 1: single search (serials that includes the value)
    if (value.length === 1) {
      setFilterQuery((prev) => {
        const prevFilterQuery = _.cloneDeep(prev);
        // remove multiple serial search if exists
        if (null !== prevFilterQuery && undefined !== prevFilterQuery['serial_number_id.serial_in']) {
          delete prevFilterQuery['serial_number_id.serial_in'];
        }
        const key = 'serial_number_id.serial_contains';
        prevFilterQuery[key] = value;
        return prevFilterQuery;
      });
    } else if (value.length > 1) {
      // case 2 multiple serial search comma separated
      setFilterQuery((prev) => {
        const prevFilterQuery = _.cloneDeep(prev);
        // remove single search if exists
        if (null !== prevFilterQuery && undefined !== prevFilterQuery['serial_number_id.serial_contains']) {
          delete prevFilterQuery['serial_number_id.serial_contains'];
        }
        const key = 'serial_number_id.serial_in';
        prevFilterQuery[key] = value;
        return prevFilterQuery;
      });
    } else {
      // case 3 value === 0
      setFilterQuery((prev) => {
        const prevFilterQuery = _.cloneDeep(prev);
        if (value.length === 0) {
          if (null !== prevFilterQuery && undefined !== prevFilterQuery['serial_number_id.serial_contains']) {
            delete prevFilterQuery['serial_number_id.serial_contains'];
          }
          if (null !== prevFilterQuery && undefined !== prevFilterQuery['serial_number_id.serial_in']) {
            delete prevFilterQuery['serial_number_id.serial_in'];
          }
        }
        return prevFilterQuery;
      });
    }
  };

  // handle search button functionality to be like the press Enter key
  const handleButton = () => {
    if (inputRef.current) {
      // Create and dispatch Enter key event
      const event = new KeyboardEvent('keydown', {
        key: 'Enter',
        code: 'Enter',
        keyCode: 13,
        which: 13,
        bubbles: true,
      });
      inputRef.current.dispatchEvent(event);
    }
  };

  useEffect(() => {
    setValue([]);
  }, [ role ]);

  useEffect(() => {
    handleClick();
  }, [ value ]);

  return (
    <Box display='flex' width={ 570 } alignItems='center'>
      <Tooltip title='With only one search term, a search is made for the serial numbers that contain the term.
      With multiple search terms, a search is made for the exact serial numbers.'
      >
        <sup>
          <InfoIcon style={ { fontSize: '18px', marginRight: '5px' } } color='primary' />
        </sup>
      </Tooltip>
      <Autocomplete
        multiple
        freeSolo
        fullWidth
        size='small'
        options={ [] }
        value={ value }
        onChange={ (e, newValue) => {
          // for strings that have many values with comas paste directly
          const finalValue = newValue.flatMap((item) => { return item.split(',').map((itemValue) => { return itemValue.trim(); }); });
          setValue(finalValue);
        } }
        renderInput={ (params) => {
          return (
            <TextField
              { ...params }
              variant='outlined'
              inputRef={ inputRef }
              label='Search'
              placeholder='Type and press space or ,'
              onKeyDown={ (e) => {
                if ((e.key === ' ' || e.key === ',') && e.target.value) {
                  e.preventDefault();
                  const newTag = e.target.value.trim().replace(/,$/, '');
                  // for strings that have many values with comas paste directly
                  if (newTag && newTag.includes(',')) {
                    const newArrayTag = newTag.split(',').map((itemValue) => { return itemValue.trim(); });
                    setValue([ ...value, ...newArrayTag ]);
                  } else
                  // for simple inputs
                  if (newTag && !value.includes(newTag)) {
                    setValue([ ...value, newTag ]);
                  }
                  e.target.value = '';
                }
              } }
            />
          );
        } }
      />
      <IconButton
        aria-label='search'
        onClick={ handleButton }
        size='small'
        style={ { marginLeft: '10px' } }
      >
        <SearchIcon />
      </IconButton>
    </Box>
  );
};

export default SearchBarForReport;
